import '../styles/ServiceCard.css'
import { DynamicContentType } from '@bm-js/atlascloud-shared'
import { ServiceCardData } from '@bm-js/atlascloud-shared'
import { CLink, LinkComponentType } from './CLink'
import { useMargin } from '../utils/hooks'
import { CustomerButton } from './CustomerButton'
import { Icon } from './Icon'

type Props = {
  content: DynamicContentType<ServiceCardData>
  LinkComponent: LinkComponentType
}

export const ServiceCard = ({ content, LinkComponent }: Props) => {
  const { icon, header, html, ctaText, ctaLink } = content.data

  const margin = useMargin(content)

  return (
    <div
      className={`${margin} flex flex-col items-start rounded-2xl border border-neutral-300 p-8`}
    >
      {!!icon && (
        <div className=' mb-6 rounded-full bg-customerPrimary-400 p-3 shadow-md text-white'>
          <Icon name={icon} className='size-6' />
        </div>
      )}
      <h2 className='mb-4 font-medium text-2xl'>{header}</h2>
      <div
        className='serviceCard__richText font-light'
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {!!(ctaText && ctaLink) && (
        <CLink LinkComponent={LinkComponent} href={ctaLink}>
          <CustomerButton btnColor='dark' btnType='outline' className='mt-6'>
            {ctaText}
          </CustomerButton>
        </CLink>
      )}
    </div>
  )
}
